import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
    selector: "input [regex]"
})
export class RegexDirective {
    @Input("pattern")
    pattern: string;

    constructor(private element: ElementRef<HTMLInputElement>) {}

    @HostListener("input", ["$event.target.value"])
    onInput(value: string) {
        if (this.pattern) this.element.nativeElement.value = value.replace(new RegExp(this.pattern, "g"), "");
    }
}
